import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, catchError, of } from 'rxjs';
import { ToastService } from '../components/toast/toast.service';

export const accessGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const redirect = () => {
        const firstUrl = authService.getFirstAllowedUrl();
        if (firstUrl) {
            router.navigate(['/dashboard' + firstUrl]);
        } else {
            authService.logout();
        }
    };

    if (authService.accessData()) {
        const hasAccess = authService.hasAccess(state.url);
        if (!hasAccess) {
            redirect();
            return false;
        }
        return true;
    }

    return authService.loadAccess().pipe(
        map(() => {
            const hasAccess = authService.hasAccess(state.url);
            if (!hasAccess) {
                redirect();
                return false;
            }
            return true;
        }),
        catchError(() => {
            authService.logout();
            return of(false);
        })
    );
};
